var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCF02",
    strokeDasharray: 7,
    strokeWidth: 6.99,
    d: "M395.23 418.9c9.05-83.59-68.9-147.4-157.24-156.03-49.61-4.85-241.46-50.24-210-227"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF02",
    d: "M27.32 48.68c-9.83 0-18.28-6.69-20.53-16.28a20.982 20.982 0 0 1 2.6-15.95c2.97-4.79 7.62-8.15 13.11-9.44 1.59-.38 3.23-.57 4.85-.57 9.83 0 18.27 6.69 20.53 16.28 1.29 5.49.37 11.15-2.6 15.94-2.97 4.79-7.62 8.15-13.11 9.44-1.59.38-3.23.57-4.85.57v.01Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.7d9be6ba2699fe8ba0e2f5352552b5f7.svg";
export { ForwardRef as ReactComponent };